import React, { useRef, useState, useCallback, useEffect } from "react";

export default function BeforeAfterSlider({ before, after, height = 420, labels = true }) {
  const [pos, setPos] = useState(50);
  const containerRef = useRef(null);
  const dragging = useRef(false);

  const setFromX = useCallback((clientX) => {
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    let x = ((clientX - rect.left) / rect.width) * 100;
    x = Math.max(0, Math.min(100, x));
    setPos(x);
  }, []);

  const onDown = useCallback((e) => {
    dragging.current = true;
    const cx = e.touches ? e.touches[0].clientX : e.clientX;
    setFromX(cx);
  }, [setFromX]);

  const onMove = useCallback((e) => {
    if (!dragging.current) return;
    const cx = e.touches ? e.touches[0].clientX : e.clientX;
    setFromX(cx);
  }, [setFromX]);

  const onUp = useCallback(() => {
    dragging.current = false;
  }, []);

  useEffect(() => {
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
    window.addEventListener("touchmove", onMove, { passive: true });
    window.addEventListener("touchend", onUp);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
      window.removeEventListener("touchmove", onMove);
      window.removeEventListener("touchend", onUp);
    };
  }, [onMove, onUp]);

  return (
    <div
      ref={containerRef}
      className="ba-container rounded-xl border border-risco-border bg-white"
      style={{ height }}
      onMouseDown={onDown}
      onTouchStart={onDown}
      data-testid="before-after-slider"
    >
      <img src={before} alt="Prima" />
      <div className="ba-after" style={{ clipPath: `inset(0 0 0 ${pos}%)` }}>
        <img src={after} alt="Dopo" />
      </div>
      {labels && (
        <>
          <div className="absolute top-3 left-3 px-2 py-1 text-[10px] uppercase tracking-widest bg-risco-dark/70 text-risco-ink rounded">Prima</div>
          <div className="absolute top-3 right-3 px-2 py-1 text-[10px] uppercase tracking-widest bg-risco-accent text-white rounded">Dopo</div>
        </>
      )}
      <div className="ba-handle" style={{ left: `${pos}%` }} />
    </div>
  );
}
